__turbopack_context__.v({
  "Stepper": "ZNZWWq_Stepper",
  "Stepper__Number": "ZNZWWq_Stepper__Number",
  "Stepper__Step": "ZNZWWq_Stepper__Step",
  "Stepper__Text": "ZNZWWq_Stepper__Text",
});
